import StorageConfig from "@/services/config/StorageConfig";

export const Helper = {
    hasPermission(codename){
        try {
            let permissionList = StorageConfig.getPermissions()
            return permissionList.includes(codename)
        }catch (e){
            return false
        }
    },

    hasPermissions(codenames = []) {
        try {
            let permissionList = StorageConfig.getPermissions()
            return codenames.some(codename => permissionList.includes(codename));
        } catch (e) {
            return false;
        }
    },

    formatNumber(value, decimals = 2) {
        if (value === null || value === undefined || value === '') {
            return '0,00';
        }

        const num = parseFloat(value);
        if (isNaN(num)) {
            return '0,00';
        }

        return num.toLocaleString('id-ID', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        });
    },

    hasGroup(groupName) {
        try {
            const groups = StorageConfig.getGroups();
            if (!Array.isArray(groups)) return false;

            return groups.some(
                g => String(g?.name || '').toLowerCase() === String(groupName).toLowerCase()
            );
        } catch {
            return false;
        }
    },

    capitalizeWords(str) {
        return str
            .split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" ");
    }
}